import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix Leaflet default marker icons (bundler path issue) with CDN assets.
const icon = new L.Icon({
  iconUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png",
  iconRetinaUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

// Custom brand-colored pin for a modern look.
const accentIcon = L.divIcon({
  className: "sc-accent-pin",
  html: '<span style="display:block;width:28px;height:28px;background:#EA155B;border:3px solid #fff;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:0 6px 16px rgba(234,21,91,.45)"></span>',
  iconSize: [28, 28], iconAnchor: [14, 28], popupAnchor: [0, -30],
});

const LIGHT_TILE = "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png";
const OSM_TILE = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

/** points: [{id, lat, lng, title, subtitle}]; pin: "accent"; tile: "light" */
export const MapView = ({ points = [], height = 380, zoom = 6, center, pin, tile, grayscale }) => {
  const valid = points.filter((p) => p.lat && p.lng);
  const c = center || (valid[0] ? [valid[0].lat, valid[0].lng] : [42.5, 12.5]);
  const markerIcon = pin === "accent" ? accentIcon : icon;
  return (
    <div className={`rounded-2xl overflow-hidden border border-slate-200 shadow-sm ${grayscale ? "sc-map-gray" : ""}`} style={{ height }} data-testid="dealer-map">
      <MapContainer center={c} zoom={valid.length === 1 ? Math.max(zoom, 13) : zoom} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer attribution='&copy; OpenStreetMap, &copy; CARTO' url={tile === "light" ? LIGHT_TILE : OSM_TILE} />
        {valid.map((p) => (
          <Marker key={p.id} position={[p.lat, p.lng]} icon={markerIcon}>
            <Popup>
              <strong>{p.title}</strong>
              {p.subtitle && <><br />{p.subtitle}</>}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};
